module.exports = __webpack_public_path__ + "static/media/doctors-portal2.bcb6924f.png";